module.exports = __webpack_public_path__ + "static/young-blue-dragon-b15fb51f37f9ab62fdf4d3be6a329bce.png";